import { render, staticRenderFns } from "./GestionTareas.vue?vue&type=template&id=2caf330f&scoped=true"
import script from "./GestionTareas.vue?vue&type=script&lang=js"
export * from "./GestionTareas.vue?vue&type=script&lang=js"
import style0 from "./GestionTareas.vue?vue&type=style&index=0&id=2caf330f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2caf330f",
  null
  
)

export default component.exports